// extracted by mini-css-extract-plugin
module.exports = {"svg":"Sparkline_svg__f6GEp","empty":"Sparkline_empty__p0ySu","peakLabel":"Sparkline_peakLabel__i74eF"};